import { SportRacesTypeParamType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';

interface FilterType {
    key: SportRacesTypeParamType;
    label: string;
    onClick: () => void;
    dataTest: string;
}

const getUkAndIreLabel = (language: LanguagesState): string => {
    return language.getTranslation('sports.racing.uk-ire.label', 'UK & IRE');
};

const getInternationalLabel = (language: LanguagesState): string => {
    return language.getTranslation('sports.racing.international.label', 'International');
};

const getAntePostLabel = (language: LanguagesState): string => {
    return language.getTranslation('sports.racing.future.label', 'Future');
};

export const getFilters = (
    language: LanguagesState,
    showTrapChallenge: boolean,
    showSpecials: boolean,
    onChangeCallback: (id: SportRacesTypeParamType) => void,
    isTabletOrBigger: boolean,
    sport: 'horseracing' | 'greyhoundracing'
): Array<FilterType> => {
    const { getTranslation } = language;

    const ukAndIreLabel = getUkAndIreLabel(language);

    const internationalLabel = getInternationalLabel(language);

    const quickPickLabel = language.getTranslation('sports.racing.quick-pick.label', 'Quick Pick');

    const buildRacecardLabel = language.getTranslation('sports.racing.build-racecard.label', 'Build a Racecard');

    const trapChallengeBlock: FilterType = {
        key: 'trap-challenge',
        label: getTranslation('sports.racing.trap-challenge.label', 'Trap Challenge'),
        dataTest: getTranslation('sports.racing.trap-challenge.label', 'Trap Challenge'),
        onClick: (): void => onChangeCallback('trap-challenge'),
    };
    const antePostLabel = getAntePostLabel(language);

    const specialsFilter: FilterType = {
        key: 'specials',
        label: getTranslation('sports.racing.specials.label', 'Specials'),
        dataTest: getTranslation('sports.racing.specials.label', 'Specials'),
        onClick: (): void => onChangeCallback('specials'),
    };

    const optionQuickPick: FilterType = {
        key: 'quick-pick',
        label: quickPickLabel,
        dataTest: quickPickLabel,
        onClick: (): void => onChangeCallback('quick-pick'),
    };

    const optionBuildRaceCard: FilterType = {
        key: 'build-racecard',
        label: buildRacecardLabel,
        dataTest: buildRacecardLabel,
        onClick: (): void => onChangeCallback('build-racecard'),
    };

    const optionAntePost: FilterType = {
        key: 'ante-post',
        label: antePostLabel,
        dataTest: antePostLabel,
        onClick: (): void => onChangeCallback('ante-post'),
    };

    const optionUkAndIre: FilterType = {
        key: 'uk-ire',
        label: ukAndIreLabel,
        dataTest: ukAndIreLabel,
        onClick: (): void => onChangeCallback('uk-ire'),
    };

    const optionInternationalLabel: FilterType = {
        key: 'international',
        label: internationalLabel,
        dataTest: internationalLabel,
        onClick: (): void => onChangeCallback('international'),
    };

    let filters = [optionUkAndIre, optionInternationalLabel, optionAntePost];

    if (isTabletOrBigger) {
        const desktopFilters = [...filters.slice(0, 2), optionQuickPick, optionBuildRaceCard, ...filters.slice(2)];
        filters = desktopFilters;
    }

    if (showTrapChallenge === true) {
        filters.push(trapChallengeBlock);
    }

    if (showSpecials === true) {
        const specialsFilters = [...filters.slice(0, 2), specialsFilter, ...filters.slice(2)];
        filters = specialsFilters;
    }

    if (sport === 'greyhoundracing') {
        filters = filters.filter((filter) => filter.key !== 'international');
    }

    return filters;
};
